export default __webpack_public_path__ + "static/media/results.08158226.png";